/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinetoolpagedescription3Inputs */

const en_refinetoolpagedescription3 = /** @type {(inputs: Refinetoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an image and describe the change you want.`)
};

const de_refinetoolpagedescription3 = /** @type {(inputs: Refinetoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild hochladen und die gewünschte Änderung beschreiben.`)
};

/**
* | output |
* | --- |
* | "Upload an image and describe the change you want." |
*
* @param {Refinetoolpagedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinetoolpagedescription3 = /** @type {((inputs?: Refinetoolpagedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinetoolpagedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinetoolpagedescription3(inputs)
	return de_refinetoolpagedescription3(inputs)
});
export { refinetoolpagedescription3 as "refineToolPageDescription" }